(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const money = (cents, currency = window.Shopify?.currency?.active || 'EUR') => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    } catch {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  };

  // Mobile navigation
  const mobileToggle = $('[data-mobile-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.getAttribute('aria-hidden') === 'false';
      mobileMenu.setAttribute('aria-hidden', String(isOpen));
      mobileToggle.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  // Localization: manual choice always wins.
  $$('[data-language-selector]').forEach((select) => {
    select.addEventListener('change', () => {
      try {
        localStorage.setItem('av-language-choice', select.value);
      } catch {}
      select.form?.submit();
    });
  });

  const autoLanguageForm = $('#AutoLanguageForm');
  const languageJson = $('#AvailableLanguages');
  if (autoLanguageForm && languageJson) {
    try {
      const manual = localStorage.getItem('av-language-choice');
      const autoDone = sessionStorage.getItem('av-auto-language-done');
      if (!manual && !autoDone) {
        const available = JSON.parse(languageJson.textContent || '[]').map((item) => item.iso_code);
        const current = document.documentElement.lang;
        const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
        const aliases = {
          'zh-cn': ['zh-CN', 'zh-Hans', 'zh'],
          'zh-sg': ['zh-CN', 'zh-Hans', 'zh'],
          'zh-tw': ['zh-TW', 'zh-Hant'],
          'zh-hk': ['zh-TW', 'zh-Hant'],
          'pt-br': ['pt-BR', 'pt'],
          'pt-pt': ['pt-PT', 'pt']
        };

        let desired = null;
        for (const candidateRaw of browserLanguages.filter(Boolean)) {
          const candidate = candidateRaw.toLowerCase();
          const attempts = [
            ...(aliases[candidate] || []),
            candidateRaw,
            candidateRaw.split('-')[0]
          ];
          desired = attempts.find((attempt) =>
            available.some((code) => code.toLowerCase() === String(attempt).toLowerCase())
          );
          if (desired) {
            desired = available.find((code) => code.toLowerCase() === desired.toLowerCase());
            break;
          }
        }

        sessionStorage.setItem('av-auto-language-done', '1');
        if (desired && desired !== current) {
          const input = $('[data-auto-language-input]', autoLanguageForm);
          if (input) {
            input.value = desired;
            autoLanguageForm.submit();
          }
        }
      }
    } catch {}
  }

  // Cart drawer
  const drawer = $('[data-cart-drawer]');
  const drawerBody = $('[data-cart-drawer-body]');
  const drawerFooter = $('[data-cart-drawer-footer]');
  const totalNode = $('[data-cart-total]');
  let lastFocused = null;

  const setCount = (count) => {
    $$('[data-cart-count]').forEach((node) => {
      node.textContent = count;
      node.hidden = count < 1;
    });
  };

  const renderCart = async () => {
    if (!drawerBody) return;
    drawerBody.innerHTML = `<p class="cart-drawer__loading">${window.themeStrings?.loading || 'Loading…'}</p>`;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      const cart = await response.json();
      setCount(cart.item_count);
      if (!cart.item_count) {
        drawerBody.innerHTML = `
          <div class="drawer-empty">
            <p>${window.themeStrings?.emptyCart || 'Your cart is empty.'}</p>
            <a class="button button--primary" href="${window.Shopify?.routes?.root || '/'}collections/all">${window.themeStrings?.continueShopping || 'Continue shopping'}</a>
          </div>`;
        if (drawerFooter) drawerFooter.hidden = true;
        return;
      }

      drawerBody.innerHTML = cart.items.map((item, index) => `
        <article class="drawer-item">
          <a href="${item.url}">
            ${item.image ? `<img src="${item.image}&width=160" alt="${String(item.product_title).replace(/"/g, '&quot;')}">` : ''}
          </a>
          <div>
            <h3><a href="${item.url}">${item.product_title}</a></h3>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<small>${item.variant_title}</small>` : ''}
            <p>${money(item.final_line_price, cart.currency)}</p>
          </div>
          <button type="button" data-cart-remove="${index + 1}" aria-label="${window.themeStrings?.remove || 'Remove'}">×</button>
        </article>
      `).join('');
      if (totalNode) totalNode.textContent = money(cart.total_price, cart.currency);
      if (drawerFooter) drawerFooter.hidden = false;
    } catch {
      drawerBody.innerHTML = `<p>${window.themeStrings?.cartError || 'Unable to load cart.'}</p>`;
    }
  };

  const openDrawer = async () => {
    if (!drawer) return;
    lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    await renderCart();
    $('[data-cart-close]', drawer)?.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    lastFocused?.focus?.();
  };

  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') closeDrawer();
  });

  drawer?.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    remove.disabled = true;
    await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(remove.dataset.cartRemove), quantity: 0 })
    });
    await renderCart();
  });

  // AJAX product forms
  $$('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!drawer || form.dataset.noAjax === 'true') return;
      event.preventDefault();
      const submit = form.querySelector('[type="submit"]');
      const original = submit?.textContent;
      if (submit) {
        submit.disabled = true;
        submit.textContent = window.themeStrings?.adding || 'Adding…';
      }
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Add failed');
        await openDrawer();
      } catch {
        form.submit();
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = original;
        }
      }
    });
  });

  // Product variant selector
  $$('form.product-form').forEach((form) => {
    const select = $('[name="id"]', form);
    const price = $('[data-product-price]');
    const button = $('[type="submit"]', form);
    if (!select) return;
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        const available = option.dataset.available === 'true';
        button.disabled = !available;
        button.textContent = available
          ? (window.themeStrings?.addToCart || 'Add to cart')
          : (window.themeStrings?.soldOut || 'Sold out');
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      history.replaceState({}, '', url);
    });
  });

  // Predictive-style simple search opener
  $$('[data-search-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const path = `${window.Shopify?.routes?.root || '/'}search`;
      window.location.assign(path);
    });
  });


  // Shopify product recommendations section
  $$('[data-product-recommendations]').forEach(async (container) => {
    try {
      const response = await fetch(container.dataset.url);
      const html = await response.text();
      const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
      const replacement = parsedDocument.querySelector('[data-product-recommendations]')?.parentElement
        || parsedDocument.querySelector('.section');
      if (replacement) container.replaceWith(replacement);
    } catch {}
  });

  // Cookie consent UI (uses Shopify customer privacy API when available)
  const cookieBanner = $('[data-cookie-banner]');
  if (cookieBanner) {
    const stored = (() => { try { return localStorage.getItem('av-cookie-choice'); } catch { return null; } })();
    if (!stored) cookieBanner.hidden = false;
    $('[data-cookie-accept]', cookieBanner)?.addEventListener('click', () => {
      try { localStorage.setItem('av-cookie-choice', 'accepted'); } catch {}
      if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(true, () => {});
      }
      cookieBanner.hidden = true;
    });
    $('[data-cookie-reject]', cookieBanner)?.addEventListener('click', () => {
      try { localStorage.setItem('av-cookie-choice', 'rejected'); } catch {}
      if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
        window.Shopify.customerPrivacy.setTrackingConsent(false, () => {});
      }
      cookieBanner.hidden = true;
    });
  }

  // Keep cart count synced after browser back/forward.
  window.addEventListener('pageshow', async () => {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      const cart = await response.json();
      setCount(cart.item_count);
    } catch {}
  });
})();
